import React, { useEffect, useState } from 'react'
import ManageModule from './ManageReuseble/ManageModule'
import CircularProgress from '@mui/material/CircularProgress';
import { Field } from 'formik';
import { Chip } from '@mui/material';
import StanderdConstants from '../../services/StanderdConstants';


function Role() {
    const [Data, setData] = useState('')
    const [recentData, setRecentformData] = useState('');
    const [insertionStatus, setInsertionStatus] = useState(false);
    const [datakeys, setdatakeys] = useState([]) // table heading names without id , if you want to show all columns , pass it in tableheadings
    const tableName = "staticroles"
    const [updatedRoles, setupdatedRoles] = useState()

        


    useEffect(() => {
        if (insertionStatus) {
            setInsertionStatus(false);
            getData()
        }
    }, [insertionStatus, recentData]);
    const getData = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/manage/getData   `, {
            method: 'Post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tablename: StanderdConstants.TABLENAME_STATICROLES })

        })
        const result = await response.json();
        if (response.ok) {
            setData(result.data)
            setdatakeys(Object.keys(result.data[0]).slice(1))
        }
    }
        useEffect(() => {
        getData()

    }, [])

    useEffect(() => {
        if (Data.length > 0) {
            const updatedata = Data?.map(role => ({
                ...role,
                isReserved: role.isReserved === "1" ? (
                    <Chip label="Reserved" color="primary" />
                ) : (
                    <Chip label="Not Reserved" color="primary" />
                )
            }))

            setupdatedRoles(updatedata)
        }
    }, [Data])

    const columns = [
        { header: StanderdConstants.HEADER_ROLE, field: StanderdConstants.COLUMN_DBTABLE_ROLE },
        { header: StanderdConstants.HEADER_IS_RESERVED, field: StanderdConstants.COLUMN_DBTABLE_IS_RESERVED },
        { header: StanderdConstants.HEADER_STATUS, field: StanderdConstants.COLUMN_DBTABLE_STATUS }
    ];


    return (
        <div>
            {
                Data?.length && datakeys?.length > 0
                    ? <ManageModule
                        pageHeading='Roles'
                        permissionprefix='Roles'
                        data={Data}
                        tableHeadings={datakeys}  // can give table heading  name in array too eg ['h1','h5']
                        tableName={StanderdConstants.TABLENAME_STATICROLES}
                        formfieldNames={['Role', 'isReserved', 'StatusId']} // can gives fields name in array too. eg. ['column1','column5']
                        setRecentformData={setRecentformData}
                        setInsertionStatus={setInsertionStatus}
                        columns={columns}
                    />
                    :
                    <center><CircularProgress /></center>
            }



        </div>
    )
}

export default Role
